/**
 * GanttLegend Component - Status legend and business hours toggle
 */
import React from 'react';

interface GanttLegendProps {
  isBusinessHours: boolean;
  setIsBusinessHours: (value: boolean) => void;
}

export const GanttLegend: React.FC<GanttLegendProps> = ({
  isBusinessHours,
  setIsBusinessHours,
}) => {
  const legendItems = [
    { color: 'bg-gray-400', label: 'Pré-Agendada' },
    { color: 'bg-blue-500', label: 'Agendada' },
    { color: 'bg-cyan-500', label: 'Confirmada' },
    { color: 'bg-purple-500 animate-pulse', label: 'Em Execução' },
    { color: 'bg-green-500', label: 'Executada' },
    { color: 'bg-orange-500', label: 'Não Autorizada' },
    { color: 'bg-red-500', label: 'Não Executada' },
    { color: 'bg-slate-400', label: 'Cancelada' },
  ];

  return (
    <div className="mt-4 bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 px-6 py-4 flex flex-col md:flex-row items-center justify-between gap-4">
      <div className="flex flex-wrap items-center gap-6">
        <span className="font-semibold text-gray-700 dark:text-gray-300 text-sm">Legenda:</span>
        {legendItems.map(({ color, label }) => (
          <div key={label} className="flex items-center gap-2">
            <div className={`w-3 h-3 rounded-full ${color}`}></div>
            <span className="text-sm text-gray-600 dark:text-gray-400">{label}</span>
          </div>
        ))}
      </div>

      {/* Business Hours Toggle */}
      <div className="flex items-center gap-3 pl-0 md:pl-6 md:border-l border-gray-200 dark:border-gray-700">
        <label className="relative inline-flex items-center cursor-pointer">
          <input
            type="checkbox"
            className="sr-only peer"
            checked={isBusinessHours}
            onChange={() => setIsBusinessHours(!isBusinessHours)}
          />
          <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
          <span className="ml-3 text-sm font-medium text-gray-900 dark:text-gray-300 whitespace-nowrap">Horário Comercial (06h-20h)</span>
        </label>
      </div>
    </div>
  );
};
